<template>
  <div>
    <v-tabs color="primary" dark slider-color="yellow" class="">
      <v-tab @click="selected = '' " ripple>ALL</v-tab>
      <v-tab v-for="service in services" :key="service" 
      @click="selected = service" ripple >
      {{ service }}
    </v-tab>
  </v-tabs>
  <v-toolbar text color="white">
    <v-toolbar-title>Price Book</v-toolbar-title>
    <v-divider
    class="mx-2"
    inset
    vertical
    ></v-divider>
    <v-spacer></v-spacer>
    <v-text-field
    class=""
    v-model="selected"
    append-icon="search"
    label="Search"
    single-line
    hide-details
    ></v-text-field>
    <v-spacer></v-spacer>

    <v-dialog v-model="dialog" max-width="500px" :persistent="keepOpen">
      <template v-slot:activator="{ on }">
        <v-btn @click="defaultService" color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-row wrap>

              <v-col cols="12" class="py-0">
                <template>
                  <v-sheet
                  v-if="!editedItem.imageUrl"
                  color="darken-2"
                  class="px-0 pt-3 pb-3"
                  >
                  <v-skeleton-loader
                  class="mx-auto"
                  height="150"
                  type="image"
                  boilerplate
                  ></v-skeleton-loader>
                </v-sheet>
              </template>
              <v-img contain class="px-3 pt-3 pb-3" v-if="editedItem.imageUrl" :src="editedItem.imageUrl" height="150"></v-img>
            </v-col>

            <v-col cols="12" sm="6" md="4" class="mx-auto">
              <v-btn class="primary text-right float-right" @click="onPickFile" >Upload Image</v-btn>
              <input type="file" style="display: none;" ref="fileInput" accept="image/*" @change="onFilePicked">
            </v-col>
            <v-row>
              <v-col cols="6" sm="6" md="4">
                <v-combobox 
                class="text-capitalize"
                :items="services"
                v-model="editedItem.service"
                label="Service"
                placeholder="Or Create New"
                :disabled="!$store.state.user.admin"
                >
              </v-combobox>
            </v-col>

            <v-col cols="6" sm="6" md="4">
              <v-select
              text-capitalize
              class="text-capitalize"
              :items="groups.map(v=>v.name)"
              v-model="editedItem.group" label="Group"
              >
            </v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field class="text-capitalize" text-capitalize v-model="editedItem.title" label="Title"></v-text-field>
          </v-col>
        </v-row>

        <v-col cols="12">
          <v-textarea outlined height="100" counter="100" text-capitalize v-model="editedItem.description" maxlength="100" label="Description"></v-textarea>
        </v-col>


        <v-col cols="12" sm="6" md="4">
          <v-text-field text-capitalize v-model="editedItem.price" placeholder="0" label="Price" type="number"></v-text-field>
        </v-col> 
        <v-col cols="12" sm="6" md="4">
          <v-text-field text-capitalize v-model="editedItem.coupon" label="Coupon" type="number"></v-text-field>
        </v-col>

        <v-col cols="12" v-if="uploader" class="">
          Upload Progress:
          <v-progress-linear
          :value="uploader"
          height="25"
          reactive
          readonly
          >
          <strong>{{ Math.ceil(uploader) }}%</strong>
        </v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</v-card-text>

<v-card-actions>
  <v-spacer></v-spacer>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-checkbox left v-on="on" label="Keep This Open" v-model="keepOpen"></v-checkbox>
    </template>
    <span>Check This Box To Add Multiple Items Fast</span>
  </v-tooltip>
  <v-spacer></v-spacer>
  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
  <v-btn color="blue darken-1" text @click="save" >Save</v-btn>
</v-card-actions>
</v-card>
</v-dialog>
<addGroup />
<!-- <addImage /> -->
</v-toolbar>

<v-data-table
text-capitalize
:items-per-page="itemsPerPage"
:headers="headers"
:items="pricebook"
:search="selected"
class="elevation-1 text-capitalize"
>
<template v-slot:item.imageUrl="{ item }">
 <v-img :src="item.imageUrl" width="75" class="ma-2"></v-img>
</template>

<template v-slot:item.action="{ item }">
  <v-btn v-if="$store.state.user.admin || item.created == $store.state.user.id" @click="editItem(item)" class="ml-2 mt-1" color="info"> 
    <v-icon medium class="d-inline pr-2"> edit </v-icon>
    Edit
  </v-btn>
  <v-btn v-if="$store.state.user.admin || item.created == $store.state.user.id" @click.stop="deleteDialog = true, Item = item" color="#D32F2F" dark class="ml-2 mt-1">
    <v-icon medium class="darken-4 d-inline pr-1"> delete </v-icon>
    <!-- &nbsp;Del&nbsp; -->
  </v-btn>
</template>

<template v-slot:no-results>
  <div class="text-xs-center">
    Nothing To Display
  </div>
</template>
</v-data-table>

<template>
  <v-dialog v-model="deleteDialog" max-width="340">
    <v-card>
      <v-card-title class="title">Delete Item?</v-card-title>
      <v-card-text>
        Are you sure you want to delete "{{Item.title}}"?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" text @click="deleteDialog = false"> Cancel </v-btn>
        <v-btn color="error darken-1" text @click="deleteItem()"> Delete </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
</div>

</template>

<script>
import firebase from '@/helpers/firebaseConfig'
// import addImage from '../components/Image'
import addGroup from '../components/Groups'
const db = firebase.firestore()
export default {
  components: { addGroup},
  data: () => ({
    dialog: false,
    files: [],
    uploader: null,
    Item: {},
    deleteDialog: false,
    dialog: false,
    selected: '',
    search: '',
    keepOpen: false,
    headers: [
    { text: 'Image', align: 'left', value: 'imageUrl', width: 100},
    { text: 'Title', align: 'left', value: 'title'},
    { text: 'Description', value: 'description', width: 290},
    { text: 'Price', value: 'price' },
    { text: 'Service', value: 'service' },
    { text: 'Group', value: 'group' },
    { text: 'Coupon', value: 'coupon', width: 10 },
    { text: 'Actions', value: 'action', sortable: false, align: 'end' }
    ],
    itemsPerPage: 10,
    totalItems: 0,
    // pricebook: [],
    editedIndex: -1,
    editedItem: {
      imageUrl: undefined,
      title: '',
      description: '',
      service: '',
      group: '',
      price: null,
      coupon: 0,
      id: '',
      editing: false
    },
    defaultItem: {
      imageUrl: undefined,
      title: '',
      description: '',
      service: '',
      group: '',
      price: null,
      coupon: 0,
      editing: false,
      isCap: false,
      capPrice: null,
      id: '',
    },
    deleteIndex: -1,
    // service: '',
    rules: [(value)=>value.length >= 3 || 'Please enter a value'],
    max100chars: v => v.length <= 100 || 'Input too long!'

  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
    cId () {
      return this.$store.getters.user.cId
    },
    pricebook () {
      return this.$store.getters.pricebook
    },
    services () {
      return this.$store.getters.services
    },
    groups () {
      // let all = ["LEVEL 01", "LEVEL 02", "LEVEL 03", "LEVEL 04", "LEVEL 05", "LEVEL 06", "LEVEL 07", "LEVEL 08", "LEVEL 09", "LEVEL 10", "MISC" ]
      // return [...new Set([].concat(all, this.$store.getters.groups))]
      return this.$store.getters.groups
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    defaultService(){
      if (!this.$store.state.user.admin){
        this.editedItem.service = this.$store.state.user.service
      }
    },
    loadService(service) {
      // this.selected = service
    },
    editItem (item) {
      this.editedIndex = this.$store.state.pricebook.indexOf(item)
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedItem = {...this.defaultItem, ...item}
      this.$store.commit('updateEditItemInfo', item)
      this.dialog = true
    },
    deleteItem () {
      let item = this.Item
      db.collection('trash').add({...item, deletedBy: this.$store.state.user.email})
      db.collection('items').doc(item.id).delete()
      this.deleteDialog = false
      this.$store.commit('setSnack', `"${item.title}" Was Successfully Destroyed`)
      this.Item = {}
    },
    close () {
      this.keepOpen === true ? this.dialog = true : this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.files = new Array()
        this.dialog = false
        this.uploader = null
      }, 300)
    },
    onPickFile (event) {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      this.files = event.target.files
      let filename = this.files[0].name
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!')
      }
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.editedItem.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(this.files[0])
    },
    save () {
      setTimeout(()=> {
        // if (this.editedItem.imageUrl == '' || this.editedItem.title == '' || this.editedItem.service == ''){
        //   return this.$store.commit('setSnack', 'Title And Image Are Required')
        // }
        if (!this.$store.state.user.admin){
          this.editedItem.service = this.$store.state.user.service
        }
        if (this.editedItem.price == null){
          this.editedItem.price = 0
        }
        if (this.editedItem.coupon == null){
          this.editedItem.coupon = 0
        }
        this.editedItem.service = this.editedItem.service.toString().toUpperCase()
        let file = this.files[0]
        let _this = this
        
        if (file != undefined) {

          let storageRef = firebase.storage().ref(`${this.cId}/${this.editedItem.service}/${this.files[0].name}`)
          let task = storageRef.put(file)

          task.on('state_changed',
          // progress 
          (snapshot) => {
            console.log('snapshot ', snapshot)
            let percentage = ( snapshot.bytesTransferred / 
              snapshot.totalBytes) * 100
            this.uploader = percentage
          },
          // error
          (err) => {
            this.$store.commit('setSnack', 'Couldn\'t Save')
          },
          // complete
          () => {
            task.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              // console.log('File available at', downloadURL)
              _this.editedItem.imageUrl = downloadURL

              // db.collection('items').add({..._this.image, cId: _this.$store.getters.user.cId, created: _this.$store.state.user.id})
              if (_this.editedIndex > -1) {
                // update
                db.collection('items2').doc(_this.editedItem.id).set({..._this.editedItem, edited: [{user: _this.$store.state.user.email}]}, {merge: true});
                db.collection('items').doc(_this.editedItem.id).update({..._this.editedItem})
                _this.$store.commit('setSnack', 'Item Saved!')
                _this.close()
              } else {
                // save new
                db.collection('items').add({..._this.editedItem, cId: _this.$store.getters.user.cId, created: _this.$store.state.user.id})
                _this.$store.commit('setSnack', 'Item Saved!')
                _this.close()
              }

            })
          })
        } else {
          db.collection('items2').doc(_this.editedItem.id).set({..._this.editedItem, edited: [{user: _this.$store.state.user.email}]}, {merge: true});
          db.collection('items').doc(_this.editedItem.id).update({..._this.editedItem})
          _this.$store.commit('setSnack', 'Item Saved!')
          _this.close()
        }

      }, 10) // end set timeout
    }
  } 
}

</script>
